// Responsive renditions of the hero poster (the LCP element on the homepage).
//
// vite-imagetools emits 480/768/1280-wide WebP files at build time; the
// browser then downloads the single rendition that matches the viewport
// instead of the full-width original. Quality is raised slightly to 78 —
// the poster sits behind a dark gradient, so the extra compression is
// invisible while the transfer stays small.
//
// The same three constants feed the <img> and the <link rel="preload"> in
// the homepage head, so preload and render resolve to the exact same file.

import heroSrcSet from "@/assets/hero-paris-night.jpg?w=480;768;1280&format=webp&quality=78&as=srcset";
import heroFallback from "@/assets/hero-paris-night.jpg?w=1280&format=webp&quality=78";

export const HERO_SRC: string = heroFallback;
export const HERO_SRCSET: string = heroSrcSet;
export const HERO_SIZES = "100vw";
